import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=af8349a6&"
import script from "./SectionCard.vue?vue&type=script&lang=ts&"
export * from "./SectionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports